import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import axios from 'axios';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    marginTop: '20px'
  },
  paper: {
    marginTop: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  },
  alert: {
    textAlign: 'center',
    color: 'red'
  }
}));

function ResetPassword(props) {
  const { authError, auth } = props;

  const [forgetState, setForget] = React.useState({
    userName: '',
    OTP: ''
  });

  const [newPasswordState, setNewPassword] = React.useState({
    password: ''
  });

  const [otherInput, showOtherInput] = React.useState(false);
  const handleForgetPasswordChange = (event) => {
    setForget({ ...forgetState, [event.target.name]: event.target.value });
  };

  const handleNewPasswordChange = (event) => {
    setNewPassword({
      ...newPasswordState,
      [event.target.name]: event.target.value
    });
  };

  const submitEmailAndOpt = () => {
    axios
      .post(
        'https://dev-api.grospick.com/api_v_1/user/verify-forget-password-otp',
        forgetState
      )
      .then((response) => {
        showOtherInput(true);
        localStorage.setItem('tokenId', response.data.data);
        alert(
          'The verification code is correct, now you can create a new password.'
        );
      })
      .catch((error) => {
        alert(error.message);
        console.error('There was an error!', error);
      });
  };

  const submitNewPassword = () => {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('tokenId')
    };
    axios
      .post(
        'https://dev-api.grospick.com/api_v_1/user/reset-password',
        newPasswordState,
        {
          headers: headers
        }
      )
      .then((response) => {
        alert('Your new password is successfully set, thanks a lot!');
      })
      .catch((error) => {
        alert(error.message);
        console.error('There was an error!', error);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    submitEmailAndOpt();
  };

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    submitNewPassword();
  };
  const classes = useStyles();
  return (
    <div className={classes.content}>
      {auth ? (window.location.href = '/admin2') : ''}
      <br />
      <br />
      <br />
      {otherInput === false ? (
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <div className={classes.paper}>
            <Avatar className={classes.avatar}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Reset Password
            </Typography>
            <form className={classes.form} noValidate onSubmit={handleSubmit}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="userName"
                label="Email Address"
                name="userName"
                autoComplete="userName"
                autoFocus
                onChange={handleForgetPasswordChange}
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="OTP"
                label="Verification code"
                type="text"
                id="OTP"
                autoComplete="current-password"
                onChange={handleForgetPasswordChange}
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                style={{ backgroundColor: '#34BA92' }}
                className={classes.submit}
              >
                Verify Code
              </Button>
              {authError ? <p className={classes.alert}>{authError}</p> : null}
            </form>
          </div>
          <Box mt={8}></Box>
        </Container>
      ) : (
        ' '
      )}
      {otherInput === true ? (
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <div className={classes.paper}>
            <Avatar className={classes.avatar}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Enter a new Password
            </Typography>
            <form
              className={classes.form}
              noValidate
              onSubmit={handlePasswordSubmit}
            >
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="password"
                label="Enter a new password"
                type="password"
                id="password"
                autoComplete="current-password"
                onChange={handleNewPasswordChange}
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                style={{ backgroundColor: '#34BA92' }}
                className={classes.submit}
              >
                Create password
              </Button>
              {authError ? <p className={classes.alert}>{authError}</p> : null}
            </form>
          </div>
          <Box mt={8}></Box>
        </Container>
      ) : (
        ' '
      )}
    </div>
  );
}

export default ResetPassword;
